import { waitPromise } from "@irati/utils/promise";
import { PLATFORM } from "@irati-web/app/src/routeConfig";
import History from "../../../../history";
import isMaintenance from "./isMaintenance";
export default function (err) {
    if (isMaintenance(err)) {
        waitPromise()
            .then(function () {
            History.push({
                pathname: "/maintenance",
                app: PLATFORM
            });
        })
            .catch(function (e) { return console.log(e); });
    }
}
